<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > <a routerLink="/diretorio-lista">{{ 'Lista de diretórios' | translate}}</a> > {{
        pathSelected }}
    </div>
</div>

<main class="container">

    <div class="add_group" [formGroup]="formDiretorio">
        <h1 i18n>{{ (isCreateMode ? 'Adicionar diretório' : 'Diretório: ') | translate}} {{ !isCreateMode ? pathSelected : '' }}</h1>

        <div class="flex form filtros">
            <div class="form-group filtro">
                <label for="status" i18n>{{ 'País' | translate }}:</label>
                <select id="status" formControlName="Countryid" (change)="onCountryChange()">
                    <option value="" i18n>{{ 'Selecione um país' | translate }}</option>
                    <option *ngFor="let pais of jsonPaises" [value]="pais.id">{{ pais.name }}</option>
                </select>
            </div>
            <div class="form-group filtro">
                <label i18n>{{ 'Status' | translate }}:</label>
                <label class="checkbox-label">
                    <input type="checkbox" formControlName="Status">
                    <span i18n>{{ 'Ativo' | translate }}</span>
                </label>
            </div>

            <div class="form-group filtro">
                <label i18n>{{ 'Ano do filtro' | translate }}:</label>
                <input type="number" class="form-control size-index" formControlName="FilterYear" min="1000" max="9999" (change)="onFilterYearChange()">
            </div>

            <div class="form-group filtro">
                <label i18n>{{ 'Mês do filtro' | translate }}:</label>
                <select formControlName="FilterMonth">
                    <option value="" i18n>{{ 'Selecione o mês' | translate }}</option>
                    <option *ngFor="let mes of mesesDisponiveis" [value]="mes">{{ mes }}</option>
                </select>
            </div>

            <div class="form-group filtro">
                <label i18n>{{ 'Limitar PDVs' | translate }}:</label>
                <select formControlName="isLimitPdvs">
                    <option [ngValue]="true" i18n>{{ 'Sim' | translate }}</option>
                    <option [ngValue]="false" i18n>{{ 'Não' | translate }}</option>
                </select>
            </div>
        </div>
        <div class="flex form filtros">
            <div class="form-group filtro">
                <label i18n for="grupo">{{ 'Caminho' | translate }}:</label>
                <input type="text" id="grupo" class="form-control" style="width:570px !important;" formControlName="RootPath">
            </div>
       </div>



        <!-- Upload oculto temporariamente a pedido -->
        <div class="flex form filtros upload-pdv" *ngIf="false && formDiretorio.get('isLimitPdvs')?.value">
            <div class="form-group filtro">
                <label i18n for="pdvFile">{{ 'Arquivo de PDVs' | translate }}:</label>
                <input type="file" id="pdvFile" class="form-control pdv-file-input" (change)="onPdvFileSelected($event)">
                <small *ngIf="selectedPdvFileCount !== null">
                    {{ 'Quantidade de PDVs no arquivo: {{count}}' | translate: { count: selectedPdvFileCount } }}
                </small>
            </div>

            <div class="form-group filtro">
                <label i18n>&nbsp;</label>
                <button class="red_button" (click)="uploadDirectoryPdv()" type="button" [disabled]="uploadingPdv" i18n>
                    {{ 'Upload' | translate }}
                </button>
            </div>

            <div class="form-group filtro">
                <label>&nbsp;</label>
                <button type="button" class="red_button" (click)="downloadPdvTemplate()" title="{{ 'Download do layout CSV para upload de PDVs' | translate }}">
                    {{ 'Download Layout' | translate }}
                </button>
            </div>
        </div>

        <div class="flex form filtros">


            <div class="form-group filtro">
                <label i18n>&nbsp;</label>
                <button class="red_button" (click)="saveDirectory()" type="button" i18n>
                    {{ (isCreateMode ? 'Adicionar' : 'Salvar') | translate }}
                </button>
            </div>
        </div>
    </div>
</main>
